$(() => {
  $('.btn-circle-toggle[data-bs-toggle="collapse"]').on('click', function() {
    const $this = $(this)
    const $text = $this.find('span')

    if($this.attr('aria-expanded') == "true") {
      $text.text('実績を閉じる')
    }else {
      $text.text('すべての実績を見る')
    }
  })
})